import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const BankTransferManagement = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Banka Transfer Yönetimi
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>Banka transfer yönetimi burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default BankTransferManagement;
